import Vue from 'vue'
import capitalize from '@/tools/capitalize'

Vue.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  let value_arr = value.split('_');
  return value_arr.map(v => capitalize(v)).join(' ');
});
